module.exports = __webpack_public_path__ + "assets/svg/Icons/48/pages-blue-75c825.svg";